import { View, StyleSheet, Text } from "react-native";
import React from 'react'
import { Popover } from "@material-ui/core";

export const getColorCode = (color: string) => {
    switch (color) {
        case 'red':
            return '#FF0000';
        case 'yellow':
            return '#FFFF00';
        case 'green':
            return '#0FFF50';
        default:
            return '#000000';
    }
}

export const RygCircle = ({ backgroundColor }: { backgroundColor: string }) => {
    return (
          <View style={[styles.rygCircle, { backgroundColor }]} />
    );
};

export const RvgStatus = ({ category }: { category: {name:string, bgColor : string} }) =>{
    return(
          <View style={styles.rygStatus}>
                <RygCircle backgroundColor={category.bgColor} />
                <Text style={styles.popoverItem}>{category.name}</Text>
          </View>
    );
}


export const PopoverStatus = (anchorEl: any, handleClose?: ((event: {}, reason: "backdropClick" | "escapeKeyDown") => void)) => {
    return <Popover
        data-testId="PopoverTest"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
        }}
        PaperProps={{
            style: {
                position: 'absolute',
                top: 10,
                left: 0,
                backgroundColor: '#fff',
                padding: 10,
                borderRadius: 5,
                marginTop: 10,
                boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px -5px'
            },
        }}
        onClick={(e) => e.stopPropagation()}
    >
        <View style={styles.popoverContent} >
            <RvgStatus category={{ name: "Recommended", bgColor: "#0FFF50" }} />
            <RvgStatus category={{ name: "Permissible", bgColor: "#FFFF00" }} />
            <RvgStatus category={{ name: "Not Recommended", bgColor: "#FF0000" }} />
        </View>
    </Popover>
}

const styles = StyleSheet.create({
    rygCircle : {
        height : 12,
        width : 12,
        borderRadius : 50,
    },
    rygStatus : {
        display  :"flex",
        width : "auto",
        flexDirection  :"row",
        alignItems : "center",
        marginBottom : 10
    },
    popoverItem: {
        fontSize: 16,
        color: '#333',
        marginLeft : 15
    },
    popoverContent: {
      padding: 5,
    },
})